//@flow
import {getNotesApi, saveNotesApi, deleteNotesApi} from './api';
import {NOTE_ENTITY_TYPE} from './constants';

type SaveNoteRequest = {|
  entityType: string,
  entityId: string,
  content: string,
|};

type NoteResponse = {|
  content?: string,
  data?: {content?: string},
|};

export function getNotesContentFromResponse(
  response: NoteResponse | string | null | void
): string {
  if (!response) return '';
  if (typeof response === 'string') return response;
  if (typeof response.content === 'string') return response.content;
  if (response.data && typeof response.data.content === 'string') {
    return response.data.content;
  }
  return '';
}

export function getConversationNotesService(
  conversationId: string
): Promise<string> {
  return getNotesApi({
    entity_type: NOTE_ENTITY_TYPE,
    entity_id: conversationId,
  })
    .toPromise()
    .then(getNotesContentFromResponse)
    .catch(error => {
      if (error?.status === 404) return '';
      throw error;
    });
}

export function saveConversationNotesService(
  conversationId: string,
  content: string
): Promise<string> {
  const body: SaveNoteRequest = {
    entityType: NOTE_ENTITY_TYPE,
    entityId: conversationId,
    content,
  };

  return saveNotesApi(body)
    .toPromise()
    .then(getNotesContentFromResponse);
}

export function deleteConversationNotesService(
  conversationId: string
): Promise<void> {
  return deleteNotesApi({
    queryParams: {
      entity_type: NOTE_ENTITY_TYPE,
      entity_id: conversationId,
    },
  }).toPromise();
}
